import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 6l0 -3" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.25 7.75l2.15 -2.15" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 12l3 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.25 16.25l2.15 2.15" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 18l0 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.75 16.25l-2.15 2.15" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12l-3 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.75 7.75l-2.15 -2.15" })
	]
});
export { SvgLoader as ReactComponent };
